import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14 text-weight-500" }, "\n        総合保有ポイント\n      ", -1)
const _hoisted_2 = { class: "text-size-32 text-weight-700 pt-1" }
const _hoisted_3 = {
  key: 0,
  class: "text-mild text-size-14 text-weight-500 pt-1"
}

import { formatNumber } from "@/utils/number";
import { formatFromISOString } from "@/utils/date";
import BgWaveCard from "@/components/organisms/common/BgWaveCard.vue";
import { User } from "@/types/user/User";


export default /*#__PURE__*/_defineComponent({
  __name: 'PointCard',
  props: {
    user: {}
  },
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BgWaveCard, { class: "section1" }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _hoisted_1,
        _createTextVNode(),
        _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(formatNumber)(_ctx.user.caisukePoint)) + "pt\n      ", 1),
        _createTextVNode(),
        (_ctx.user.caisukePointExpiresAt !== null)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, "\n        有効期限:\n        " + _toDisplayString(_unref(formatFromISOString)(_ctx.user.caisukePointExpiresAt, "yyyy/MM/dd")), 1))
          : _createCommentVNode("", true)
      ])
    ], undefined, true),
    _: 1
  }))
}
}

})